"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppContext = _interopRequireWildcard(require("../../context/AppContext"));

var _CommentsIngestProvider = _interopRequireDefault(require("../CommentsIngestProvider"));

var _CallbackContext = require("../../context/CallbackContext");

var _useClearAnnotationLocation = _interopRequireDefault(require("./useClearAnnotationLocation"));

var _useComments = _interopRequireDefault(require("../../hooks/useComments"));

var _useMentions = require("../../hooks/useMentions");

var _useFetchComments = _interopRequireWildcard(require("./useFetchComments"));

var _useLegacyAnnotationDeprecationWarning = _interopRequireDefault(require("./useLegacyAnnotationDeprecationWarning"));

var _useAnnotatingBodyClasses = _interopRequireDefault(require("./useAnnotatingBodyClasses"));

var _useAnnotatingChange = _interopRequireDefault(require("./useAnnotatingChange"));

var _useOnCommentsUpdate = _interopRequireDefault(require("./useOnCommentsUpdate"));

var _useCompactLayoutChange = _interopRequireDefault(require("./useCompactLayoutChange"));

var _useSubmitCommentsInStorage = _interopRequireDefault(require("./useSubmitCommentsInStorage"));

var _reducers = require("../../reducers");

require("../../style/variables.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * CommentsProvider component
 * @reactProps {object} analyticsData - data representing the base SDM object
 * @reactProps {boolean} [annotationsEnabled=false] - boolean indicating if annotations feature should be enabled.  Setting to 'true' without providing annotationTypes defaults to legacy textarea 'pin' only.
 * @reactProps {boolean} [annotationsCreationEnabled=true] - boolean indicating if comments with annotations can be created. Default to true but only applies if annotationsEnabled is also true.
 * @reactProps {boolean} [annotationsMultiPageEnabled=false] - boolean indicating if multiple annotation overlays are visible representing different nodes
 * @reactProps {object} annotationTypes - object indicating type of annotations to be enabled.  'pin', 'text', and 'draw' properties with boolean value are allowed.  If provided, AnnotationToolbar will be displayed.
 * @reactProps {object} assetData - **required** - data related to the current asset
 * @reactProps {string} assetData.id - id of the current asset
 * @reactProps {string} assetData.nodeId - id of the node within the asset
 * @reactProps {string} assetData.ownerId - id of owner of the current asset
 * @reactProps {string} assetData.region - region of the current asset
 * @reactProps {Array} assetData.validNodes - array objects indicating the valid nodes included in the asset. Each object must contain an ID and title (and optional subtitle). This data is required for global commenting.
 * @reactProps {boolean} [authenticateFetch=true] - boolean indicating if the Authenticate header should be used for GET calls
 * @reactProps {Array} children - list of children components
 * @reactProps {string} peopleGraphAPIKey - API key for the People Graph Service
 * @reactProps {string} [environment="stage"] - current enviroment the component is running in
 * @reactProps {boolean} filterComments - boolean indicating if comments is in filter mode
 * @reactProps {boolean} disableCommentCreation - boolean indicating if comments submit box should be hidden
 * @reactProps {boolean} disableNetworkIndicator - boolean indicating if the cloud icon in the footer should be hidden
 * @reactProps {boolean} globalComments - boolean indicating if comments is in global mode
 * @reactProps {boolean} globalCommentsUnmapped - boolean indicating if an unmapped section should be added for global comments
 * @reactProps {boolean} hasReviewAccess - boolean indicating if user can view this review
 * @reactProps {boolean} imageCapture - boolean indicating if comment annotating is allowed with image context capture
 * @reactProps {boolean} imageContextData - object representing image data of comment context
 * @reactProps {object} [imsData={}] - data related to the current user
 * @reactProps {string} imsData.id - id of the current user
 * @reactProps {string} imsData.token - token of the current user
 * @reactProps {boolean} [inContextCommentingEnabled=false] - boolean indicating if in-context commenting should be enabled
 * @reactProps {boolean} isMapping - if set to true it is an indication the host is currently mapping comments
 * @reactProps {string} [locale="en-US"] - current intl locale
 * @reactProps {string} [localeStringOverrides={}] - Object that allows overriding built in translation strings
 * @reactProps {boolean} [mentionsEnabled=false] - boolean indicating if @mention feature should be enabled
 * @reactProps {boolean} [compactLayout=false] - boolean indicating if the compact layout should be enabled
 * @reactProps {function} onCommentClick - function that will be called when a comment is clicked. Executes with commentId and an object containing hasAnnotation, selector and sectionId
 * @reactProps {function} onCommentHover - function that will be called when a comment's hover state changes. Executes with commentId and an object containing isHovered, hasAnnotation, selector and sectionId
 * @reactProps {function} onAnnotatingChange - function that will be called when annotating mode is changed
 * @reactProps {function} onCloseButtonClick - function that will be called when the close button is clicked in mobile view
 * @reactProps {function} onCommentsSuccess - function that will be called when comments are initially fetched
 * @reactProps {function} onCommentsUpdate - function that will be called when comments count is updated. Returns an object with various count totals for un-resolved comments (e.g. {totalCount: <count of comments across all nodes>, nodeCount: <count of comments for the currently active node>, currentCount: <context aware count of comments based on if viewing global comments or not>}) and an array of all comments.
 * @reactProps {function} onLogin - **required** - function that will be called when user clicks the login button
 * @reactProps {function} onMobileCommentsListHeightChange - function that will be called when the height of the comments list changes in mobile view
 * @reactProps {function} onNodeChange - function that will be called when an action within commenting should trigger a node change
 * @reactProps {number} [pollForUpdates=false] - boolean indicating if we should poll Comments Service for updates
 * @reactProps {boolean} [privateLink=true] - boolean indicating if asset link is private
 * @reactProps {string} reCaptchaSiteKey - if present the guest commenting feature is enabled. This should be the public site key generated by Google's reCAPTCHA service.
 * @reactProps {boolean} [shareStatus="unshared"] - string indicating the share status of the asset. Options are "public", "orgShared", "shared", "unshared".
 * @reactProps {string} [theme="light"] - current visual theme
 * @reactProps {string} [spectrumUIScale="medium"] - Enables medium/larger tap targets on all spectrum controls
 * @reactProps {boolean} [touchControls=false] - boolean indicating if touch-specific controls should be enabled
 * @reactProps {string} typekitId - string holding typekit ID to use for Adobe Clean
 * @reactProps {boolean} [reCaptchaEnabled=true] - boolean indicating if reCaptcha is disabled for UI automation
 * @example <CommentsProvider
 *  analyticsData={{event:{guid:'abc'}}}
 *  assetData={{ id: 'urn:aaid:sc:us:2d93f65c-259b-437e-8053-854bd72480f8', ownerId: '0E4045EC57A34D477F000101@AdobeID'}}
 *  environment="dev"
 *  imsData={{id: 123, token: abc, email: 'test@adobe.com', isPaid: true, isVerified: true}}
 *  locale="fr-FR"
 *  onLogin={() => {}}
 * />
 * @returns {ReactElement} markup
 */
var CommentsProvider = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var commentsApi = (0, _useComments.default)(props.onCommentsApiUpdate);
  var appContext = (0, _react.useContext)(_AppContext.default);
  (0, _useMentions.useConfigureMentions)();
  (0, _useFetchComments.useConfigureComments)(); // Asset/comments fetch must happen after comments configure.

  (0, _useFetchComments.default)(commentsApi.enableComments, commentsApi.disableComments);
  (0, _useSubmitCommentsInStorage.default)(commentsApi.showComment);
  (0, _react.useImperativeHandle)(ref, function () {
    return commentsApi;
  });
  (0, _useLegacyAnnotationDeprecationWarning.default)(appContext.annotationsEnabled, appContext.annotationTypes, appContext.environment);
  (0, _useClearAnnotationLocation.default)();
  (0, _useAnnotatingBodyClasses.default)();
  (0, _useOnCommentsUpdate.default)();
  (0, _useCompactLayoutChange.default)();
  (0, _useAnnotatingChange.default)(props.onAnnotatingChange);
  return props.children;
});
CommentsProvider.displayName = 'CommentsProvider'; // default values for context need to be added to initialState in AppContext.js

CommentsProvider.defaultProps = {
  assetData: {},
  analyticsData: null,
  analyticsDebounce: 5000,
  annotationsEnabled: false,
  annotationsCreationEnabled: true,
  annotationsMultiPageEnabled: false,
  annotationTypes: null,
  authenticateFetch: true,
  backgroundModeEnabled: false,
  peopleGraphAPIKey: null,
  cacheComments: false,
  disableCCXWorkflow: false,
  disableCommentCreation: false,
  disableNetworkIndicator: false,
  environment: 'stage',
  filterComments: true,
  globalComments: false,
  globalCommentsUnmapped: false,
  hasReviewAccess: true,
  imageCapture: false,
  imageContextData: {},
  imsData: {},
  inContextCommentingEnabled: false,
  isMapping: false,
  isLoading: false,
  locale: 'en-US',
  localeStringOverrides: {},
  mentionsEnabled: false,
  onAnnotatingChange: function onAnnotatingChange() {},
  onCommentClick: function onCommentClick() {},
  onCommentHover: function onCommentHover() {},
  onCommentsApiUpdate: function onCommentsApiUpdate() {},
  onCommentsSuccess: function onCommentsSuccess() {},
  onNodeChange: function onNodeChange() {},
  onShare: undefined,
  privateLink: true,
  reCaptchaSiteKey: '',
  shareStatus: 'unshared',
  typekitId: 'pwg1jsp',
  reCaptchaEnabled: true,
  compactLayout: false,
  touchControls: false,
  theme: 'light',
  spectrumUIScale: 'medium',
  reviewType: 'artifact',
  richTextEntry: true
};
CommentsProvider.propTypes = {
  analyticsData: _propTypes.default.object,
  analyticsDebounce: _propTypes.default.number,
  annotationsEnabled: _propTypes.default.bool,
  annotationsCreationEnabled: _propTypes.default.bool,
  annotationsMultiPageEnabled: _propTypes.default.bool,
  annotationTypes: _propTypes.default.shape({
    draw: _propTypes.default.bool,
    pin: _propTypes.default.bool,
    text: _propTypes.default.bool
  }),
  authenticateFetch: _propTypes.default.bool,
  appKey: _propTypes.default.string.isRequired,
  assetData: _propTypes.default.object,
  backgroundModeEnabled: _propTypes.default.bool,
  peopleGraphAPIKey: _propTypes.default.string,
  cacheComments: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  disableCCXWorkflow: _propTypes.default.bool,
  disableCommentCreation: _propTypes.default.bool,
  disableNetworkIndicator: _propTypes.default.bool,
  environment: _propTypes.default.string,
  filterComments: _propTypes.default.bool,
  globalComments: _propTypes.default.bool,
  globalCommentsUnmapped: _propTypes.default.bool,
  hasReviewAccess: _propTypes.default.bool,
  imageCapture: _propTypes.default.bool,
  imageContextData: _propTypes.default.object,
  imsData: _propTypes.default.object,
  inContextCommentingEnabled: _propTypes.default.bool,
  invitationServiceAccessToken: _propTypes.default.string,
  isMapping: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  locale: _propTypes.default.string,
  localeStringOverrides: _propTypes.default.object,
  mentionsEnabled: _propTypes.default.bool,
  onAnnotatingChange: _propTypes.default.func,
  onCommentClick: _propTypes.default.func,
  onCommentHover: _propTypes.default.func,
  onNodeChange: _propTypes.default.func,
  pollForUpdates: _propTypes.default.bool,
  privateLink: _propTypes.default.bool,
  onCommentsApiUpdate: _propTypes.default.func,
  onCommentsSuccess: _propTypes.default.func,
  onShare: _propTypes.default.func,
  typekitId: _propTypes.default.string,
  reCaptchaEnabled: _propTypes.default.bool,
  shareStatus: _propTypes.default.oneOf(['public', 'orgShared', 'shared', 'unshared']),
  compactLayout: _propTypes.default.bool,
  theme: _propTypes.default.oneOf(['light', 'lightest', 'dark', 'darkest']),
  spectrumUIScale: _propTypes.default.oneOf(['medium', 'large']),
  reviewType: _propTypes.default.oneOf(['artifact', 'cloudDoc']),
  richTextEntry: _propTypes.default.bool
};

var _default = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_reducers.ReduxProvider, null, /*#__PURE__*/_react.default.createElement(_AppContext.AppProvider, props, /*#__PURE__*/_react.default.createElement(_CallbackContext.CallbackProvider, props, /*#__PURE__*/_react.default.createElement(_CommentsIngestProvider.default, null, /*#__PURE__*/_react.default.createElement(CommentsProvider, _extends({}, props, {
    ref: ref
  }))))));
});

exports.default = _default;